import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as WarningCircleRed } from 'assets/svg/icon-warning-circle-red.svg'

function IconWarningCircleRed(props: IconProps): JSX.Element {
  const title = 'icon-warning-circle-red'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <WarningCircleRed {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconWarningCircleRed
